import { useEffect } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useSelector } from "react-redux";
import Loader from "../../components/loader";
import ClientSlider from "../../components/slider/ClientSlider";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { enterPrisesPaths } from "../../routes/enterprises";

const MarketingService = () => {
  const navigate = useNavigate()
  const { isLoading2 } = useSelector((state) => state.coach.coach);
  const { isLoading } = useSelector((state) => state.coach.auth);

  const user = { name: "find-a-coach", role: "coach" };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (isLoading2 || isLoading) {
    return <Loader />;
  }
  return (
    <MenuLayout user={user}>
      <section class="ct_workshop_banner ct_px_40 py-4">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-lg-7 mb-4 mb-lg-0"
              data-aos="fade-right"
              data-aos-duration="3000"
            >
              <h2
                class="ct_fs_50_new mb-4 ct_darkblue_text"
                style={{ maxWidth: "560px" }}
              >
                Fuel Growth with Smarter{" "}
                <span className="ct_yellow_text">Marketing</span>
              </h2>
              <p
                class="mb-0 ct_fs_20 ct_darkblue_text"
                style={{ maxWidth: "613px" }}
              >
                Attract the right audience, tell your story with clarity, and
                convert leads faster Nuvio’s marketing experts help you do it
                all.
              </p>
              <div class="ct_mt_40">
                <a
                  class="ct_yellow_btn px-5 ct_fit_content"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(enterPrisesPaths?.SalesServiceSubscription);
                  }}
                >
                  Pick Your Plan
                </a>
              </div>
            </div>
            <div
              class="col-lg-5 mb-4 mb-lg-0"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <div class="ct_workshop_right_img">
                <img
                  src="../assets/img/pexels-blue-bird-7243007 (3).png"
                  alt=""
                  style={{ maxWidth: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ct_py_65 pb-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h4 className="ct_fs_24_new mb-4 text-center">
                Join the 1,200+ companies growing with us{" "}
              </h4>
              <ClientSlider
                logos={[
                  "../assets/img/client_logo_1.png",
                  "../assets/img/client_logo_2.png",
                  "../assets/img/client_logo_3.png",
                  "../assets/img/client_logo_4.png",
                  "../assets/img/client_logo_5.png",
                  "../assets/img/client_logo_6.png",
                  "../assets/img/client_logo_7.png",
                  "../assets/img/client_logo_8.png",
                ]}
              />
            </div>
          </div>
        </div>
      </section>

      <section class=" ct_py_100  ct_px_162 ">
        <div class="container-fluid">
          <div class="row">
            <div
              class="col-lg-5 mb-4 mb-lg-0"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_img_unlock_img_23">
                <div class="ct_img_unlock_img_23_left">
                  <img src="../assets/img/Image_marketing.png" alt="" />
                  <img src="../assets/img/gir_Image_3@2x.png" alt="" />
                </div>
                <div class="ct_img_unlock_img_23_right">
                  <img src="../assets/img/Image_1102.png" alt="" />
                  <img src="../assets/img/Image_1104.png" alt="" />
                </div>
              </div>
            </div>
            <div
              class="col-lg-6 ps-lg-5 mb-4 mb-lg-0 "
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <h4
                class="ct_fs_32 ct_darkblue_text mb-0"
                style={{ maxWidth: "512px" }}
              >
                {" "}
                Struggling to Make Marketing Magic? Let’s Turn the Chaos into
                Conversions
              </h4>
              <ul className="ct_pt_40">
                <li>
                  <h4 className="ct_fs_20 ct_mb_10 ct_darkblue_text mb-2">
                    {" "}
                    Leads, but not the right ones
                  </h4>
                  <p className="mb-0 ct_fs_16" style={{ maxWidth: "507px" }}>
                    You're putting in the effort, but the leads coming in
                    aren’t qualified and converting them feels like a stretch.
                  </p>
                </li>
                <li className="mt-4">
                  <h4 className="ct_fs_20 ct_darkblue_text mb-2">
                    Scattered brand story
                  </h4>
                  <p className="mb-0 ct_fs_16" style={{ maxWidth: "507px" }}>
                    Your campaigns, content, and channels aren’t aligned
                    leaving your audience confused or tuning out.
                  </p>
                </li>
                <li className="mt-4">
                  <h4 className="ct_fs_20 ct_darkblue_text mb-2">
                    Too much busywork, not enough impact
                  </h4>
                  <p className="mb-0 ct_fs_16" style={{ maxWidth: "507px" }}>
                    Your team is buried in content requests and ad tweaks,
                    with little time for strategy or results-driven planning.
                  </p>
                </li>
                <li className="mt-4">
                  <h4 className="ct_fs_20 ct_darkblue_text mb-2">
                    Falling short of ROI goals
                  </h4>
                  <p className="mb-0 ct_fs_16" style={{ maxWidth: "507px" }}>
                    Despite all the campaigns, the needle’s barely moving
                    because there’s no consistent data, direction, or system
                    behind the efforts.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="ct_px_40  pt-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="ct_video_section">
                <div className="ct_video_section_img">
                  <img src="../assets/img/Marketing_BG.png" />
                </div>
                <div className="ct_video_overlay_content text-center">
                  <div className="ct_play_icon mb-3">
                    <i class="fa-solid fa-play"></i>
                  </div>
                  <h4 className="ct_fs_32 text-white mb-3 ">
                    Why Aren’t My Marketing Efforts Delivering Results?
                  </h4>
                  <p
                    className="mb-0 mx-auto text-white ct_text_op_6"
                    style={{ maxWidth: "500px" }}
                  >
                    It’s not just about effort it’s about strategy. Nuvio
                    helps optimize your marketing approach, reach the right
                    audience, and drive smarter conversions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ct_px_40 ct_pt_65_pb_62">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h4 className="ct_fs_32 ct_darkblue_text text-center">
                Together, We Grow Smarter
              </h4>
            </div>
          </div>
          <div className="row ct_mt_60 gx-5">
            <div className="col-lg-4 mb-4">
              <div className="ct_outline_bg bg-white ct_pb_86 h-100">
                <figure className=" ct_pt_40 text-center ">
                  <img src="../assets/img/ph_magnifying-glass-fill.png" />
                  <figcaption className="ct_mt_60">
                    <h3 className="ct_fs_32 ct_darkblue_text mb-4">75%</h3>
                    <p
                      className="ct_darkblue_text ct_text_op_6 mb-0 mx-auto ct_para_scroll ct_custom_scroll"
                      style={{ maxWidth: "333px" }}
                    >
                      of companies struggle to reach the right audience. We
                      help you attract leads that convert.
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="ct_outline_bg bg-white ct_pb_86 h-100">
                <figure className=" ct_pt_40 text-center ">
                  <img src="../assets/img/iconamoon_clock-fill.png" />
                  <figcaption className="ct_mt_60">
                    <h3 className="ct_fs_32 ct_darkblue_text mb-4">60%</h3>
                    <p
                      className="ct_darkblue_text ct_text_op_6 mb-0 mx-auto ct_para_scroll ct_custom_scroll"
                      style={{ maxWidth: "333px" }}
                    >
                      of marketers are buried in manual tasks. We streamline
                      your workflow so you can focus on strategy.
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="ct_outline_bg bg-white ct_pb_86 h-100">
                <figure className=" ct_pt_40 text-center ">
                  <img src="../assets/img/icon-park-solid_message.png" />
                  <figcaption className="ct_mt_60">
                    <h3 className="ct_fs_32 ct_darkblue_text mb-4">80%</h3>
                    <p className="ct_darkblue_text ct_text_op_6 mb-0 ct_para_scroll ct_custom_scroll">
                      of campaigns miss the mark. We align your messaging,
                      tools, and timing to boost performance.
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="ct_px_40 ct_expower_shape_new_bg">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4 mb-4">
              <div>
                <h4
                  className="ct_fs_32 ct_darkblue_text"
                  style={{ maxWidth: "220px" }}
                >
                  Supercharge Your Marketing Strategy to Drive Real Growth
                </h4>
              </div>
            </div>
            <div className="col-lg-8 mb-4">
              <div className="row">
                <div className="col-md-6 ct_mb_100">
                  <figure>
                    <img src="../assets/img/target-icon.png" />
                    <figcaption className="mt-4">
                      <h4
                        className="ct_fs_22 ct_darkblue_text mb-4"
                        style={{ maxWidth: "300px" }}
                      >
                        Attract the Right Audience, Every Time
                      </h4>
                      <p
                        className="ct_fs_18 mb-0"
                        style={{ maxWidth: "319px" }}
                      >
                        Not all traffic leads to traction. With Nuvio, your
                        team can focus on high-impact campaigns that attract
                        ideal customers no more guesswork, just smart
                        targeting that delivers measurable results.
                      </p>
                    </figcaption>
                  </figure>
                </div>
                <div className="col-md-6 ct_mb_100">
                  <figure>
                    <img src="../assets/img/setting_icon_set.png" />
                    <figcaption className="mt-4">
                      <h4
                        className="ct_fs_22 ct_darkblue_text mb-4"
                        style={{ maxWidth: "300px" }}
                      >
                        Streamline Your Marketing Workflow
                      </h4>
                      <p
                        className="ct_fs_18 mb-0"
                        style={{ maxWidth: "319px" }}
                      >
                        Tired of disjointed efforts and scattered tools? Nuvio
                        simplifies campaign management from start to finish,
                        so your marketing flows as smoothly as your
                        best-performing content faster launches, cleaner
                        handoffs, better outcomes.
                      </p>
                    </figcaption>
                  </figure>
                </div>
                <div className="col-md-6 ">
                  <figure>
                    <img src="../assets/img/pixel_trophy-solid.png" />
                    <figcaption className="mt-4">
                      <h4
                        className="ct_fs_22 ct_darkblue_text mb-4"
                        style={{ maxWidth: "300px" }}
                      >
                        Equip Your Team to Market With Confidence
                      </h4>
                      <p
                        className="ct_fs_18 mb-0"
                        style={{ maxWidth: "319px" }}
                      >
                        Great marketing isn’t just about ideas it’s about
                        execution. With Nuvio, your marketers get the
                        insights, automation, and strategy support they need
                        to craft campaigns that convert and outperform the
                        competition.
                      </p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ct_px_40 ct_mt_130 ct_pt_60">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h4 className="ct_fs_32 ct_darkblue_text mb-4">
                Marketing Packages Built for Impact
              </h4>
              <p
                className="mb-0 ct_fs_20 ct_darkblue_text"
                style={{ maxWidth: "877px" }}
              >
                Whether you're a growing brand or an established player,
                choose a plan that aligns with your marketing goals complete
                with the tools, strategy, and support to help you attract,
                engage, and convert with confidence.
              </p>
            </div>
          </div>
          <div class="row ct_mt_60">
            <div class="col-lg-4  mb-5  ">
              <div
                class="ct_pricing_card "
                style={{ borderColor: "#8ECAE6" }}
              >
                <div>
                  <div class="ct_pricing_title mt-3 text-start">
                    <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                      Starter Plan
                    </p>
                    <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                      $30 <span className="ct_fs_18">/6 Months </span>
                    </h2>
                    <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                      Great for testing strategies
                    </p>
                  </div>
                  <ul class="ct_mt_30 mb-4 mt-4">
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Full marketing strategy consultation
                    </li>
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Content creation
                    </li>
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Monthly performance tracking
                    </li>
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Email support
                    </li>
                  </ul>
                </div>
                <div class="mt-auto pt-5">
                  <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                    Get Started
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-5 ">
              <div class="ct_pricing_card" style={{ borderColor: "#8ECAE6" }}>
                <div>
                  <div class="ct_pricing_title mt-3 text-start">
                    <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                      <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                        Pro Plan
                      </p>
                      <span
                        class="ct_most_popular_badge ct_flex_shrink_0"
                        style={{
                          backgroundColor: "var(--dark_blue) ",
                          color: "#fff",
                        }}
                      >
                        Most Popular
                      </span>
                    </div>
                    <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                      $100 <span className="ct_fs_18">/12 Months </span>
                    </h2>
                    <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                      Ideal for businesses ready to scale
                    </p>
                  </div>
                  <ul class="ct_mt_30 mb-4 mt-4">
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Everything in 6-month plan
                    </li>
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Advanced data analytics
                    </li>
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Quarterly marketing strategy
                    </li>
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Priority support
                    </li>
                  </ul>
                </div>
                <div class="mt-auto">
                  <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                    Get Started
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4  mb-5 ">
              <div
                class="ct_pricing_card "
                style={{ borderColor: "#8ECAE6" }}
              >
                <div>
                  <div class="ct_pricing_title mt-3 text-start">
                    <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                      Enterprise Plan
                    </p>
                    <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                      $150<span className="ct_fs_18">/36 Months </span>
                    </h2>
                    <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                      For businesses committed to sustained growth and
                      strategic marketing.
                    </p>
                  </div>
                  <ul class="ct_mt_30 mb-4 mt-4">
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Everything in 1-year plan
                    </li>
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Dedicated marketing manager
                    </li>
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Custom campaign optimization
                    </li>
                    <li className="ct_fs_18">
                      <i
                        class="fa-solid fa-check"
                        style={{ backgroundColor: "#023047" }}
                      ></i>{" "}
                      Annual performance reviews
                    </li>
                  </ul>
                </div>
                <div class="mt-auto pt-5">
                  <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="ct_looking_for_work_bg  ct_mt_130     ct_p_111_y_106"
        style={{ backgroundColor: "#FFB703" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4
              class="ct_fs_36 mb-4 text-white"
              style={{ maxWidth: "600px" }}
            >
              Ready to Find the Perfect Fit for Your Business?
            </h4>
            <p class="mb-0 ct_fs_18" style={{ maxWidth: "630px" }}>
              Explore our tailored packages and discover flexible solutions
              designed to help you scale faster, sell smarter, and succeed
              confidently.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
              onClick={(e) => {
                e.preventDefault();
                navigate(enterPrisesPaths?.SalesServiceSubscription);
              }}
            >
              View Combined Packages
            </a>
          </div>
        </div>
      </section>
      {/* this */}
      <section className="ct_px_40 ct_mt_130">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h4 className="ct_fs_32 ct_darkblue_text text-center">
                Why Leading Brands Trust Our Marketing Solutions
              </h4>
            </div>
          </div>
          <div className="row ct_mt_60 gx-5">
            <div className="col-md-4 mb-5">
              <div className="ct_outline_bg ct_winning_team_card_12">
                <figure className="mb-0 ct_mt_70">
                  <img src="../assets/img/3_direction.png" />
                  <figcaption className="ct_mt_30">
                    <p className="ct_fs_24_new">
                      Empower Teams with Smarter Sales Solutions
                    </p>
                    <div className="ct_plus_icon_circle ms-auto">
                      <i class="fa-solid fa-plus"></i>
                    </div>
                    <div className="ct_winning_team_overlay_content">
                      <ul>
                        <li className="d-flex align-items-start gap-2">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Accelerate Sales Performance with the Right Tools
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>Unlock Sales Innovation to Stay Ahead</span>
                        </li>
                      </ul>
                    </div>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div className="col-md-4 mb-5">
              <div className="ct_outline_bg ct_winning_team_card_12">
                <figure className="mb-0 ct_mt_70">
                  <img src="../assets/img/3_direction.png" />
                  <figcaption className="ct_mt_30">
                    <p className="ct_fs_24_new">
                      Accelerate Sales Performance with the Right Tools
                    </p>
                    <div className="ct_plus_icon_circle ms-auto">
                      <i class="fa-solid fa-plus"></i>
                    </div>
                    <div className="ct_winning_team_overlay_content">
                      <ul>
                        <li className="d-flex align-items-start gap-2">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Equip your team with powerful tools that simplify
                            every stage of the sales journey.
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            Gain real-time insights to track progress, adjust
                            strategies, and stay ahead of the competition.
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Deliver a seamless experience across teams,
                            ensuring everyone works toward the same goals with
                            clarity and precision.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div className="col-md-4 mb-5">
              <div className="ct_outline_bg ct_winning_team_card_12">
                <figure className="ct_mt_70 mb-0">
                  <img src="../assets/img/solid_dark_setting.png" />
                  <figcaption className="ct_mt_30">
                    <p className="ct_fs_24_new">
                      Unlock Sales Innovation to Stay Ahead
                    </p>
                    <div className="ct_plus_icon_circle ms-auto">
                      <i class="fa-solid fa-plus"></i>
                    </div>
                    <div className="ct_winning_team_overlay_content">
                      <ul>
                        <li className="d-flex align-items-start gap-2">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Adopt forward-thinking strategies that help your
                            team adapt in a fast-changing market.
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            Leverage cutting-edge tools and insights to
                            uncover new growth opportunities.
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Continuously evolve your sales approach to outpace
                            competitors and deliver exceptional value.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class=" ct_px_40 pt-0 ct_mt_80  ">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 ">
              <div class="ct_about_cnt ">
                <h2
                  class=" ct_fs_32  mb-0 ct_darkblue_text"
                  style={{ maxWidth: "600px" }}
                >
                  Why Marketers Love Partnering with Nuvio
                </h2>

                <div class="ct_faq_question_main ct_faq_question_yellow_plus ct_mt_70">
                  <div class="accordion" id="faq_accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faq_one">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_one"
                          aria-expanded="false"
                          aria-controls="collapsefaq_one"
                        >
                          <img
                            src="../assets/img/target-icon.png"
                            width="24px"
                            className="me-2"
                          />
                          Accelerated Deal Velocity
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_one"
                        class="accordion-collapse collapse"
                        aria-labelledby="faq_one"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            With Nuvio, your team can skip the manual busywork
                            and focus on what really matters. Our platform
                            ensures smoother handoffs between teams, and keeps
                            the momentum going so no opportunity stalls out or
                            slips through the cracks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqtwo">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Two"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                        >
                          <img
                            src="../assets/img/target-icon.png"
                            width="24px"
                            className="me-2"
                          />
                          Smarter, Data-Backed Decisions
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Two"
                        class="accordion-collapse collapse "
                        aria-labelledby="faqtwo"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            With Nuvio, your team can skip the manual busywork
                            and focus on what really matters. Our platform
                            ensures smoother handoffs between teams, and keeps
                            the momentum going so no opportunity stalls out or
                            slips through the cracks.
                          </p>
                          {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqthree">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Three"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Three"
                        >
                          <img
                            src="../assets/img/target-icon.png"
                            width="24px"
                            className="me-2"
                          />
                          Empowered, High-Performing Teams
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Three"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqthree"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            With Nuvio, your team can skip the manual busywork
                            and focus on what really matters. Our platform
                            ensures smoother handoffs between teams, and keeps
                            the momentum going so no opportunity stalls out or
                            slips through the cracks.
                          </p>
                          {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqFour">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Four"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Four"
                        >
                          <img
                            src="../assets/img/target-icon.png"
                            width="24px"
                            className="me-2"
                          />
                          Scalable Success, Every Step
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Four"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqFour"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            With Nuvio, your team can skip the manual busywork
                            and focus on what really matters. Our platform
                            ensures smoother handoffs between teams, and keeps
                            the momentum going so no opportunity stalls out or
                            slips through the cracks.
                          </p>
                          {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5  ">
              <div class="ct_about_img">
                <img
                  src="../assets/img/pexels-fauxels-318283434.png"
                  class="ct_img_h_579"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </section>

      <section
        data-aos="fade-right"
        data-aos-duration="1500"
        class="ct_looking_for_work_bg   ct_looking_for_work_bg_left   ct_p_111_y_106 ct_mt_200"
        style={{ backgroundColor: "#FB8500" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">Let’s Make Magic Together </h4>
            <p class="mb-0 ct_fs_18 ct_fw_300">
              Big ideas, bold moves, and all the support you need we’re here
              to help you shine.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
              onClick={(e) => {
                e.preventDefault();
                navigate(coachPaths?.ContactUs, {
                  state: { data: "landing" },
                });
              }}
            >
              Talk to Us
            </a>
          </div>
        </div>
      </section>

      <section
        className="ct_px_40 ct_py_130 pb-0 ct_mb_100"
        data-aos="fade-down"
        data-aos-duration="1500"
      >
        <div className="container-fluid">
          {/* convert into slider */}
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div class="ct_testimonial_review_card h-100 d-grid">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                    <div class="d-flex align-items-center gap-1">
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                    </div>
                    <p className="mb-0 ct_fs_16">20th April, 2025</p>
                  </div>
                  <p className="mb-0 " style={{ maxWidth: "295px" }}>
                    The expert sessions and networking inside NuForge are next level. I finally feel part of a serious community that pushes me to grow.
                  </p>
                </div>
                <div className="mt-auto">
                  <div class="d-flex align-items-center gap-3 ct_mt_40">
                    <img
                      src="/assets/img/Ellipse 24.png"
                      class="ct_img_60 "
                      alt=""
                    />
                    <div>
                      <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                        Alex Robertson
                      </h5>
                      <p class="mb-0  ct_fs_16  ">Frontend Developer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div class="ct_testimonial_review_card h-100 d-grid">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                    <div class="d-flex align-items-center gap-1">
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                    </div>

                    <p className="mb-0 ct_fs_16">20th April, 2025</p>
                  </div>
                  <p className="mb-0 " style={{ maxWidth: "295px" }}>
                    With NuForge, I refined my services, rebranded my profile, and doubled my client reach in just a few weeks. Totally worth it!
                  </p>
                </div>
                <div className="mt-auto">
                  <div class="d-flex align-items-center gap-3 ct_mt_40">
                    <img
                      src="/assets/img/Ellipse 24 (1).png"
                      class="ct_img_60 "
                      alt=""
                    />
                    <div>
                      <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                        Olivia Brooks
                      </h5>
                      <p class="mb-0  ct_fs_16  ">Mobile App Developer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div class="ct_testimonial_review_card h-100 d-grid">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                    <div class="d-flex align-items-center gap-1">
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                    </div>

                    <p className="mb-0 ct_fs_16">20th April, 2025</p>
                  </div>
                  <p className="mb-0 " style={{ maxWidth: "295px" }}>
                    NuForge helped me position myself for higher-paying clients by improving my portfolio and strategy.
                  </p>
                </div>
                <div className="mt-auto">
                  <div class="d-flex align-items-center gap-3 ct_mt_40">
                    <img
                      src="/assets/img/Ellipse 24 (2).png"
                      class="ct_img_60 "
                      alt=""
                    />
                    <div>
                      <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                        James Thornton
                      </h5>
                      <p class="mb-0  ct_fs_16  ">Cloud Solutions Architect</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MenuLayout>
  );
};

export default MarketingService;